const C = require("../constants");

const listRecipeStock = recipes_stock => {
    return {
        type: C.RECIPES_STOCK,
        recipes_stock
    }
};

const updateRecipeStock = recipe_stock => {
    return {
        type: C.RECIPES_STOCK_UPDATE,
        recipe_stock
    }
};

export {
    listRecipeStock,
    updateRecipeStock
};


// WEBPACK FOOTER //
// ./src/actions/RecipeStockActions.js